import { useState, useContext } from "react";
import { FaChevronDown } from "react-icons/fa";
import { globalStates } from "../App";

export default function Hero({ show, navList }) {
  const [openNav, setOpenNav] = useState(false);
  const { sectionInView, setSectionInView } = useContext(globalStates);
  return (
    <header
      className={`
      ${show ? " translate-y-0" : "-translate-y-full"} 
        transition-transform fixed top-0 w-full flex flex-col items-center sm:bg-color1 bg-color2  select-none z-20`}
    >
      <div
        className="sm:hidden w-full flex justify-between items-center p-4"
        onClick={() => {
          setOpenNav((oldValue) => !oldValue);
        }}
      >
        <h3 className=" text-3xl">{navList[sectionInView].text}</h3>

        <FaChevronDown
          className={`h-8 w-8 transition-transform duration-700 ${
            openNav ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>
      <nav
        className={`${
          openNav ? "h-screen " : " h-0"
        } flex flex-col sm:h-16 sm:flex-row sm:justify-between items-center sm:w-2/4 w-full transition-all duration-500 ease-out overflow-y-hidden overflow-x-hidden `}
      >
        {navList.map((value, index) => {
          return value.url === "/" ? null : (
            <a
              key={index}
              className={`${
                // if openNav is true then show the navigation otherwise don't show it
                openNav ? " translate-x-0" : " translate-x-96"
              }  sm:m-0 sm:translate-x-0 my-10 text-xl link-hover ${
                // if this navLink is the one being viewed, then add link-opened class to it
                sectionInView === index ? "link-opened " : null
              }`}
              style={{
                // each nav-link should have more delay than
                transitionDuration: `${index + 4}00ms`,
              }}
              onClick={() => {
                // change the index of viewing page
                setSectionInView(index);
                // close the nav
                setOpenNav(false);
              }}
              href={value.url}
            >
              {value.text}
            </a>
          );
        })}
      </nav>
    </header>
  );
}
